import { MfeLoad } from '@carvana/microfrontend';
import { useEffect, useRef } from 'react';
import { MfeReactComponent } from '@carvana/microfrontend-react';

import MicroFallback from '../components/_shared/MicroFallback';
import useMfeInterface from '../context/useMfeInterface';
import { startSpan } from '../utilities/dataDog';

const AppraisalModule = () => {
  const mfeInterface = useMfeInterface();

  useEffect(() => {
    MfeLoad({
      files: [
        [
          'AppraisalModule',
          [
            {
              component: 'default',
              local: {
                file: 'index.js',
                manifest: `http://localhost:5005/assets-manifest.json?v=${Date.now()}`
              },
              default: {
                file: 'index.js',
                manifest: `${
                  process.env.CARVANA_APP_STATIC_PUBLIC_URL
                }/stc-appraisal-ui/modules/assets-manifest.json?v=${Date.now()}`
              }
            }
          ]
        ]
      ]
    });
  }, []);

  const mfeLoadSpan = useRef(startSpan('MFE:Appraisal', 'Load'));
  return (
    <MfeReactComponent
      component="default"
      module="AppraisalModule"
      loading={<MicroFallback span={mfeLoadSpan.current} />}
      fallback={{
        Component: <MicroFallback errorReportTimeout={1} span={mfeLoadSpan.current} />,
        timeout: 8000
      }}
    >
      {({ Component }) => {
        mfeLoadSpan.current.addEvent('Success');
        mfeLoadSpan.current.end();
        return <Component mfeInterface={mfeInterface} />;
      }}
    </MfeReactComponent>
  );
};

export default AppraisalModule;
